export default __webpack_public_path__ + "static/media/brother.9515d9f5.ogg";